import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Digital from "./views/Digital.vue";
import Gestion from "./views/Gestion.vue";
import Location from "./views/Location.vue";
import Partenariats from "./views/Partenariats.vue";
import Syndic from "./views/Syndic.vue";
import Transaction from "./views/Transaction.vue";
import Legal from "./views/Legal.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/digital",
      name: "digital",
      component: Digital
    },
    {
      path: "/partenariats",
      name: "partenariats",
      component: Partenariats
    },
    {
      path: "/gestion",
      name: "gestion",
      component: Gestion
    },
    {
      path: "/location",
      name: "location",
      component: Location
    },
    {
      path: "/transaction",
      name: "transaction",
      component: Transaction
    },
    {
      path: "/syndic",
      name: "syndic",
      component: Syndic
    }, {
      path: "/legal",
      name: "legal",
      component: Legal
    },
    {
      path: '*',
      redirect: 'home'
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});